import { useActiveWeb3React } from ".";
import { HEARTS_NFT_ADDRESS, YTS } from "../constants";
import { useContract } from "./useContract";
import HEART_NFT_ABI from '../constants/abis/nft-heart.json'
import { useHeartNftContract } from './useContract'
import { useSingleCallResult } from '../state/multicall/hooks'
import { ChainId, JSBI } from '@yetiswap/sdk'
import { useTransactionAdder } from '../state/transactions/hooks'
import { useMemo, useState } from 'react'
import { calculateGasMargin } from '../utils'
import { TransactionResponse } from '@ethersproject/providers'
import { NFTMarketPlaceCallBackState, useGetNFTPrice } from './useNFTMarketPlace'
import { Contract } from "ethers";
import { getSaleFromName } from "../pages/NFTMarketPlace/data/SaleList";



const useSale = (name: string) => {
    const yts = YTS[ChainId.AVALANCHE]
    const { chainId } = useActiveWeb3React();
    const [amount, setAmount] = useState<number>(1)
    const saleData = getSaleFromName(name);
    const ABI: any = saleData.ABI;
    const contract = useContract(chainId ? saleData.Addresses[chainId] : undefined, ABI, true)
    const setMintAmount = (_amount: number) => { setAmount(_amount) };
    const hasSaleStarted = useHasSaleStarted(contract);
    const startTime = useStartTime(contract);
    const mintPrice = useCalculatePrice(contract, 1);
    const calculatingPrice = useCalculatePrice(contract, amount);
    const calculatingPriceText: string = useGetNFTPrice(calculatingPrice, yts, hasSaleStarted)
    const mintPriceText: string = useGetNFTPrice(mintPrice, yts, hasSaleStarted)
    const totalMinted = useGetTotalSupply(contract);
    const { claimNFTCallback, error } = useClaimNFT(contract, amount, JSBI.BigInt(calculatingPrice ? calculatingPrice : 0).toString())

    return {
        hasSaleStarted,
        startTime,
        mintPrice,
        mintPriceText,
        calculatingPrice,
        calculatingPriceText,
        totalMinted,
        setMintAmount,
        mintNFT: claimNFTCallback,
        mintNFTError: error
    }
}
export default useSale;

function useCalculatePrice(contract: Contract | null, amount: number): number {
    //const contract = useHeartNftContract()
    const priceResult = useSingleCallResult(contract, 'price')
    let result = 0

    if (!priceResult.loading && priceResult.result) {
        result = parseInt(JSBI.multiply(JSBI.BigInt(priceResult.result?.[0]), JSBI.BigInt(amount)).toString(), 0)
    }
    return result
}

function useCurrentPrice(contract: Contract | null): number {
    //const contract = useHeartNftContract()
    const priceResult = useSingleCallResult(contract, 'price')
    let result = 0

    if (!priceResult.loading && priceResult.result) {
        result = parseInt(JSBI.BigInt(priceResult.result?.[0]).toString(), 0)
    }
    return result
}

function useStartTime(contract: Contract | null): number {
    //const contract = useHeartNftContract()
    const priceResult = useSingleCallResult(contract, 'startTime')
    let result = 0

    if (!priceResult.loading && priceResult.result) {
        result = parseInt(JSBI.BigInt(priceResult.result?.[0]).toString() + "000", 0)
    }
    return result
}

function useGetTotalSupply(contract: Contract | null): number {
    //const contract = useHeartNftContract()
    const totalSupplyResult = useSingleCallResult(contract, 'totalSupply')
    let result = 0

    if (!totalSupplyResult.loading && totalSupplyResult.result) {
        result = parseInt(JSBI.BigInt(totalSupplyResult.result?.[0]).toString(), 0)
    }
    return result
}

function useHasSaleStarted(contract: Contract | null): boolean {
    //const contract = useHeartNftContract()
    const hasSaleStartedResult = useSingleCallResult(contract, 'mintFlag')
    let result = false

    if (!hasSaleStartedResult.loading && hasSaleStartedResult.result) {
        if (hasSaleStartedResult.result?.[0] == 0)
            result = false
        else
            result = true
    }
    return result
}

function useClaimNFT(
    contract: Contract | null,
    amount: number,
    price: string
): {
    claimNFTState: NFTMarketPlaceCallBackState
    claimNFTCallback: null | (() => Promise<string>)
    error: string | null
} {
    const addTransaction = useTransactionAdder()
    //const contract = useHeartNftContract()
    return useMemo(() => {
        if (!contract) {
            return {
                claimNFTState: NFTMarketPlaceCallBackState.INVALID,
                claimNFTCallback: null,
                error: 'Missing dependencies'
            }
        }

        const args = [amount]

        return {
            claimNFTState: NFTMarketPlaceCallBackState.VALID,
            claimNFTCallback: async function onBuyNFT(): Promise<string> {
                return await contract.estimateGas['mint'](...args, { value: price }).then(estimatedGasLimit => {
                    return contract
                        .mint(...args, { value: price, gasLimit: calculateGasMargin(estimatedGasLimit) })
                        .then((response: TransactionResponse) => {
                            return response.wait(1).then((e: any) => {
                                let result = 'NFT Claimed Failed'
                                if (e && e.status === 1) {
                                    result = 'NFT Claim Successful'
                                }
                                addTransaction(response, {
                                    summary: result
                                })
                            })
                        })
                        .catch((error: any) => {
                            // if the user rejected the tx, pass this along
                            if (error?.code === 4001) {
                                console.error(`'Transaction rejected claimNFT.'`, error)
                            } else {
                                // otherwise, the error was unexpected and we need to convey that
                                console.error(`NFT Buy failed`, error)
                            }
                            return error
                        })
                })
            },
            error: null
        }
    }, [addTransaction, contract, price, amount])
}